{
  "labelsRacun": {
    "opozorilo": "Cliccando su 'Elimina', il tuo account verrà disattivato. Una volta disattivato, non potrai più accedere né utilizzare il programma WingSI.",
    "potrdiIzbris": "Sei sicuro di voler cancellare/disattivare il tuo account? Una volta disattivato, non potrai più accedere né utilizzare il programma WingSI.",
    "potrjenIzbris": "Account utente eliminato/disattivato con successo. Verrai disconnesso dall'applicazione tra pochi secondi.",
    "napakaIzbrisa": "Si è verificato un errore durante l'eliminazione dell'account. Contatta l'amministratore dell'aeroporto.",
    "napakaPilota": "Al momento non siamo riusciti a stabilire un collegamento con il pilota. Si prega di contattare l'amministratore dell'aeroporto.",
    "buttons": {
      "odpri": "Procedi con l'eliminazione/disattivazione",
      "izbrisi": "Elimina"
    }
  }
}